module.exports = __webpack_public_path__ + "img/AICAD-LOGO.2ac4f97f.png";